var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"bg-gray rounded-sm"},[_c('div',[(_vm.image)?_c('img',{staticClass:"w-full h-56",style:({
        objectFit: _vm.image.fit,
        backgroundColor: _vm.image.color || 'transparent',
      }),attrs:{"src":_vm.image.source,"alt":_vm.image.alt}}):_vm._e()]),_c('div',{staticClass:"p-7"},[_c('MainTitle',{staticClass:"text-3xl border-b-4 border-primary mx-auto w-fit mb-6",attrs:{"tag":"h3"}},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"text-lg"},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }